<cdx-slotted-modal (close)="close()" size="medium">
    <h1 modal-header>Choose a 1hr window</h1>
    <div modal-content class="modal-content-with-sticky-button">
        <div [formGroup]="changeFlexibleSlotModalForm" data-cy="form">
            <div>
                <p>
                    Orders are delivered by our Partner Drivers for <b>{{getFlexibleFulfilmentFee() | currency:'NZD':'symbol-narrow':'1.0-0'}}</b>
                    plus a <b>$1.50</b> bag fee. You can't include restricted products like alcohol or tobacco.
                    <ng-container *ngIf="getFlexibleDeliveryMaxItems()">Max {{getFlexibleDeliveryMaxItems()}} items can be added to your order.</ng-container>
                </p>
            </div>
            <fulfilment-flexible-delivery-slot-multiple-selection
                [slots]="flexibleDeliverySlots"
                [controlName]="controlName"
                [formGroup]="changeFlexibleSlotModalForm"
                (timeslotSelectedEvent)="getSelected($event)">
            </fulfilment-flexible-delivery-slot-multiple-selection>
            <br>
            <button
                cdxButton
                [disabled]="!isOkEnabled"
                (click)="handleOk()"
                fillStyle="primary"
                size="small"
                inline="true"
                type="submit" class="flexibleButton sticky-button"
                endSlotSize="extra-small"
                endSlotActive="true"
                [buttonState]="continueButtonState">
                OK
            </button>
        </div>
    </div>
</cdx-slotted-modal>
